export default __webpack_public_path__ + "static/media/round-started.1a9f10a8.mp3";